import React from "react";
import "./togather.css";

const Togather = () => {
  return (
    <div className="togather-wrapper">
      <div className="container">
        <div className="togather-main">
          <div className="main-title">
            <h4>Get your</h4>
            <h5 className="d-flex">
              ship&nbsp;<span className="lightGreen">together</span>
            </h5>
          </div>
          <p className="regular-title">
            We Provide Top projects in Solana <br />
            <span className="lightGreen">trust Spid3r</span> to ship with
            quality, <br /> security and speed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Togather;
